import React from 'react';
import cn from 'classnames';

import { CardSkeleton } from 'components/widgets/CardView/CardSkeleton/CardSkeleton';
import { getImageSizeParams } from 'utils/getImageSizeParams';

import { RailSettings } from '../RailProvider/types';

import styles from './RailSkeleton.module.scss';

interface Props {
  handleRef?: (node: HTMLDivElement) => void;
  settings: RailSettings;
  numberOfCells: number;
  shouldShowHeader?: boolean;
  isGrid?: boolean;
  className?: string;
}

function RailSkeleton({ handleRef, settings, numberOfCells, isGrid, shouldShowHeader = false, className }: Props) {
  const { imageHeight, imageWidth } = getImageSizeParams(settings); // should be removed after fallback params becomes required

  return (
    <div ref={handleRef} className={cn(styles.railSkeleton, className, { [styles.grid]: isGrid })}>
      {shouldShowHeader && (
        <header
          style={{
            width: imageWidth,
          }}
        />
      )}
      <div>
        {new Array(numberOfCells).fill(0).map((_, i) => {
          /* eslint-disable react/no-array-index-key */
          return <CardSkeleton key={i} height={imageHeight ?? 0} width={imageWidth} />;
        })}
      </div>
    </div>
  );
}

export default RailSkeleton;
